import { render, staticRenderFns } from "./GiftLetter.vue?vue&type=template&id=27ca92ae&"
import script from "./GiftLetter.vue?vue&type=script&lang=js&"
export * from "./GiftLetter.vue?vue&type=script&lang=js&"
import style0 from "./GiftLetter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports